import {Injectable, signal} from '@angular/core';
import {Context} from '../../models/context';

@Injectable({providedIn: 'root'})
export class ContextService {
  private readonly _context = signal<Context | null>(null);

  readonly context = this._context; // expose as readonly signal

  setContext(ctx: Context) {
    this._context.set(ctx);
  }

  isSet(): boolean {
    return this._context()?.isSet?.() ?? false;
  }
  
}
